import { gql } from '@apollo/client';

const SIGN_PRIVACY_TERM = gql`
  mutation signTerm($userId: Float!) {
    signPrivacyTerm(userId: $userId)
  }
`;

export { SIGN_PRIVACY_TERM };
